export default "__VITE_ASSET__BE94KD0B__"